{
  "app.name": "Sun",
  "app.by": "by ArchiSimple",
  "language.label": "Language",
  "common.back": "Back",
  "common.close": "Close",
  "common.done": "Done",
  "welcome.title": "See the sun's path, right where you stand",
  "welcome.intro": "Hold your phone up to the sky: the sun's path is drawn over the camera image, for any day of the year.",
  "welcome.needs": "What the app needs",
  "welcome.camera": "Camera",
  "welcome.cameraWhy": "To draw the path over what you see. No image ever leaves the phone.",
  "welcome.location": "Location",
  "welcome.locationWhy": "To work out where the sun is here. You can also search for an address.",
  "welcome.motion": "Motion and orientation",
  "welcome.motionWhy": "To know where the phone points: compass and tilt.",
  "welcome.privacy": "Everything is computed on your phone. Nothing is sent or stored, except the words of an address you search for.",
  "welcome.start": "Get started",
  "welcome.manual": "Choose a place without GPS",
  "welcome.insecure": "This page must be opened over HTTPS: browsers give the camera and the sensors only to a secure page.",
  "motion.title": "Allow access to motion",
  "motion.body": "On iPhone, Safari asks for your consent before giving out the phone's compass and tilt. Without them, the path cannot follow your movements.",
  "motion.preview": "What you will see next",
  "motion.prompt": "Safari will ask whether this site may access motion and orientation.",
  "motion.hint": "Tap Allow in Safari's window. You can change your mind in Settings › Safari.",
  "motion.continue": "Continue",
  "motion.skip": "Continue without sensors",
  "compass.chip": "Compass · true north · ±{degrees}°",
  "compass.chipSettling": "Compass · true north",
  "compass.chipPoor": "Compass disturbed",
  "compass.open": "Fix the compass",
  "compass.title": "Compass",
  "compass.accuracy": "Accuracy",
  "compass.good": "Good · ±{degrees}°",
  "compass.fair": "Fair · ±{degrees}°",
  "compass.poor": "Poor",
  "compass.settling": "Measuring…",
  "compass.trueNorth": "True north: the magnetic declination here ({degrees}°) is corrected automatically.",
  "compass.eightTitle": "Direction looks wrong?",
  "compass.eightBody": "Move away from metal objects, then wave the phone in a figure 8 to wake the compass up.",
  "ar.horizon": "Horizon",
  "ar.sunrise": "Sunrise {time} · {degrees}°",
  "ar.sunset": "Sunset {time} · {degrees}°",
  "ar.sun": "Sun",
  "ar.summary": "Day summary",
  "ar.heading": "The phone points at {degrees}°",
  "ar.direction": "Direction",
  "ar.height": "Height",
  "ar.directionValue": "{degrees}° · {point}",
  "ar.above": "{degrees}° above the horizon",
  "ar.below": "{degrees}° below the horizon",
  "ar.now": "Now",
  "ar.play": "Play the day",
  "ar.pause": "Pause",
  "ar.time": "Time",
  "ar.hour": "{hour}:00",
  "ar.highest": "{date} · highest",
  "ar.lowest": "{date} · lowest",
  "ar.locating": "Finding your position…",
  "ar.view": "The sun's path over the camera image",
  "point.north": "north",
  "point.north-east": "north-east",
  "point.east": "east",
  "point.south-east": "south-east",
  "point.south": "south",
  "point.south-west": "south-west",
  "point.west": "west",
  "point.north-west": "north-west",
  "cardinal.n": "N",
  "cardinal.e": "E",
  "cardinal.s": "S",
  "cardinal.w": "W",
  "date.title": "Date and time",
  "date.open": "Change the date",
  "date.days": "Day of the year",
  "date.date": "Date",
  "date.compare": "Also show the equinox",
  "preset.today": "Today",
  "preset.spring": "Spring equinox",
  "preset.summer": "Summer solstice",
  "preset.autumn": "Autumn equinox",
  "preset.winter": "Winter solstice",
  "zone.named": "Local time, {season} (UTC{offset}) · from your phone",
  "zone.summer": "summer time",
  "zone.standard": "standard time",
  "zone.approximate": "Approximate local time (UTC{offset}): no time zone is known for a typed place, so the time is set from its longitude, with no summer time. The sun's position for that time is exact.",
  "summary.title": "Day summary",
  "summary.sunrise": "Sunrise",
  "summary.noon": "Solar noon",
  "summary.sunset": "Sunset",
  "summary.length": "Day length",
  "summary.lengthValue": "{hours} h {minutes} min",
  "summary.longer": "{minutes, plural, one {# min longer than yesterday} other {# min longer than yesterday}}",
  "summary.shorter": "{minutes, plural, one {# min shorter than yesterday} other {# min shorter than yesterday}}",
  "summary.same": "Same as yesterday",
  "summary.polarDay": "The sun does not set",
  "summary.polarNight": "The sun does not rise",
  "summary.today": "This day",
  "summary.references": "Solstices and equinox",
  "summary.diagram": "The sun's path seen from above: this day, and the solstices dotted",
  "summary.north": "Directions are from true north.",
  "summary.back": "Back to the view",
  "location.title": "Choose a place",
  "location.mine": "Use my location",
  "location.search": "Address, town, place or coordinates",
  "location.privacy": "Only the text you type is sent to the address service, from 3 letters. Nothing else leaves the phone.",
  "location.searching": "Searching…",
  "location.none": "No place found. Try a town, or coordinates such as 48.8566, 2.3522.",
  "location.failed": "The address service cannot be reached. Type coordinates instead, such as 48.8566, 2.3522.",
  "location.results": "Suggestions",
  "location.typed": "Typed coordinates",
  "location.coordinates": "{latitude}°, {longitude}°",
  "location.chosen": "Chosen place",
  "location.credits": "Addresses: Base Adresse Nationale · © OpenStreetMap contributors (Photon)",
  "location.unavailable": "Your location is not available. Search for the place instead.",
  "location.use": "Use this place",
  "place.device": "Your position",
  "place.manual": "Chosen place",
  "place.accuracy": "GPS ±{metres} m",
  "place.change": "Change the place",
  "fallback.camera.title": "Camera not available",
  "fallback.camera.body": "The path is drawn on a plain sky. Allow the camera in your browser's settings to see it over the real image.",
  "fallback.sensors.title": "No compass on this device",
  "fallback.sensors.body": "On a computer, or when motion access is refused, the sky does not follow the device: drag it instead.",
  "fallback.compass.title": "Compass disturbed",
  "fallback.compass.body": "A metal object or a magnet is skewing the direction. Move away, then wave the phone in a figure 8.",
  "fallback.retry": "Try again",
  "fallback.drag": "Drag to look around you"
}
